import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=77c66af4&scoped=true"
import script from "./UserManual.vue?vue&type=script&lang=ts"
export * from "./UserManual.vue?vue&type=script&lang=ts"
import style0 from "./UserManual.vue?vue&type=style&index=0&id=77c66af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c66af4",
  null
  
)

export default component.exports